// Форматирование времени
export const formatTime = (date) => {
  return date.toLocaleString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

// Форматирование временного интервала
export const formatTimeInterval = (startTime, endTime) => {
  const start = new Date(startTime);
  const end = new Date(endTime);
  
  const formatTime = (date) => {
    return date.toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  return `${formatTime(start)}-${formatTime(end)}`;
};

// Определение статуса на основе процента успешных запросов
export const determineStatus = (successRate) => {
  if (successRate >= 95) return 'ok';
  if (successRate >= 80) return 'warning';
  return 'error';
};

// Получение иконки статуса
export const getStatusIcon = (status) => {
  switch (status) {
    case 'ok':
      return '🟢';
    case 'warning':
      return '🟡';
    case 'error':
      return '🔴';
    default:
      return '⚪';
  }
};

// Получение цвета статуса
export const getStatusColor = (status) => {
  switch (status) {
    case 'ok':
      return '#10b981';
    case 'warning':
      return '#f59e0b';
    case 'error':
      return '#ef4444';
    default:
      return '#6b7280';
  }
};

// Получение текста статуса
export const getStatusText = (status) => {
  switch (status) {
    case 'ok':
      return 'OK';
    case 'warning':
      return 'Warning';
    case 'error':
      return 'Error';
    default:
      return 'Unknown';
  }
};

// Подсчет процента ошибок
export const calculateErrorPercentage = (errors, totalRequests) => {
  if (!totalRequests || totalRequests === 0) return 0;
  const totalErrors = Object.values(errors).reduce((sum, count) => sum + count, 0);
  return Math.round((totalErrors / totalRequests) * 100);
};

// Форматирование числа с разделителями
export const formatNumber = (number) => {
  return number.toLocaleString('ru-RU');
};

// Группировка ошибок по кодам
export const groupErrorsByCode = (errorLogs) => {
  const errorGroups = {};
  
  errorLogs.forEach(error => {
    const code = error.statusCode || error.code || 'unknown';
    errorGroups[code] = (errorGroups[code] || 0) + 1;
  });
  
  return errorGroups;
};

// Создание детального описания модуля
export const createModuleDetails = (moduleData) => {
  const { name, totalRequests, processedRequests, pendingRequests, completedRequests } = moduleData;
  
  switch (name.toLowerCase()) {
    case 'статус системы':
    case 'system_status':
      return 'Все сервисы активны, система стабильна';
    
    case 'трекинг заказов':
    case 'order_tracking':
      return `Обработано заказов: ${formatNumber(processedRequests || 0)}/${formatNumber(totalRequests || 0)}`;
    
    case 'доставка':
    case 'delivery':
      const pending = pendingRequests || 0;
      const delayed = moduleData.delayedOrders || 0;
      return `Задержка ${delayed} заказов, ${pending} ожидают подтверждения`;
    
    case 'монтаж':
    case 'installation':
      return moduleData.status === 'error' 
        ? 'Критические ошибки, требуется вмешательство'
        : 'Монтажные работы выполняются в штатном режиме';
    
    case 'завершённые заказы':
    case 'completed_orders':
      const completed = completedRequests || 0;
      const total = totalRequests || 0;
      return `Завершено заказов: ${formatNumber(completed)} из ${formatNumber(total)} за последние 30 дней`;
    
    default:
      return 'Модуль работает в штатном режиме';
  }
}; 